export default __webpack_public_path__ + "static/media/img11.c86ae9a4.png";